import axios from 'axios';
import constants from '../../const.js';

// Action Types
const CHAT_CONVERSATIONS_REQUEST = "CHAT_CONVERSATIONS_REQUEST";
const CHAT_CONVERSATIONS_SUCCESS = "CHAT_CONVERSATIONS_SUCCESS";
const CHAT_CONVERSATIONS_FAILURE = "CHAT_CONVERSATIONS_FAILURE";

const CHAT_MESSAGES_REQUEST = "CHAT_MESSAGES_REQUEST";
const CHAT_MESSAGES_SUCCESS = "CHAT_MESSAGES_SUCCESS";
const CHAT_MESSAGES_FAILURE = "CHAT_MESSAGES_FAILURE";

const CHAT_SEND_MESSAGE_REQUEST = "CHAT_SEND_MESSAGE_REQUEST";
const CHAT_SEND_MESSAGE_SUCCESS = "CHAT_SEND_MESSAGE_SUCCESS";
const CHAT_SEND_MESSAGE_FAILURE = "CHAT_SEND_MESSAGE_FAILURE";

const SET_ACTIVE_CONVERSATION = "SET_ACTIVE_CONVERSATION";
const TOGGLE_CHAT_OPEN = "TOGGLE_CHAT_OPEN";
const SET_UNREAD_COUNT = "SET_UNREAD_COUNT";

// Action Creators
const getConversationsRequest = () => ({
  type: CHAT_CONVERSATIONS_REQUEST
});

const getConversationsSuccess = (conversations) => ({
  type: CHAT_CONVERSATIONS_SUCCESS,
  conversations
});

const getConversationsFailure = (error) => ({
  type: CHAT_CONVERSATIONS_FAILURE,
  error
});

const getMessagesRequest = () => ({
  type: CHAT_MESSAGES_REQUEST
});

const getMessagesSuccess = (messages, conversationId) => ({
  type: CHAT_MESSAGES_SUCCESS,
  messages,
  conversationId
});

const getMessagesFailure = (error) => ({
  type: CHAT_MESSAGES_FAILURE,
  error
});

const sendMessageRequest = () => ({
  type: CHAT_SEND_MESSAGE_REQUEST
});

const sendMessageSuccess = (message) => ({
  type: CHAT_SEND_MESSAGE_SUCCESS,
  message
});

const sendMessageFailure = (error) => ({
  type: CHAT_SEND_MESSAGE_FAILURE,
  error
});

const setActiveConversation = (conversationId) => ({
  type: SET_ACTIVE_CONVERSATION,
  conversationId
});

const toggleChatOpen = (isOpen) => ({
  type: TOGGLE_CHAT_OPEN,
  isOpen
});

const setUnreadCount = (count) => ({
  type: SET_UNREAD_COUNT,
  count
});

// Action types for announcement channel
const CREATE_ANNOUNCEMENT_REQUEST = "CREATE_ANNOUNCEMENT_REQUEST";
const CREATE_ANNOUNCEMENT_SUCCESS = "CREATE_ANNOUNCEMENT_SUCCESS";
const CREATE_ANNOUNCEMENT_FAILURE = "CREATE_ANNOUNCEMENT_FAILURE";

const createAnnouncementRequest = () => ({
  type: CREATE_ANNOUNCEMENT_REQUEST
});

const createAnnouncementSuccess = (announcement) => ({
  type: CREATE_ANNOUNCEMENT_SUCCESS,
  announcement
});

const createAnnouncementFailure = (error) => ({
  type: CREATE_ANNOUNCEMENT_FAILURE,
  error
});

// Thunks
export const createAnnouncement = (name = "Announcements") => {
  return dispatch => {
    dispatch(createAnnouncementRequest());
    return axios.post(`${constants.CHAT_SERVER_URL}/announcements`, 
      { name },
      {
        headers: { 'Authorization': `${localStorage.getItem('token')}` }
      }
    )
      .then(res => {
        dispatch(createAnnouncementSuccess(res.data.data || res.data));
        // Refresh conversations list after creating announcement
        dispatch(getConversations());
      })
      .catch(error => {
        dispatch(createAnnouncementFailure(error));
      });
  };
};

export const getConversations = () => {
  return dispatch => {
    dispatch(getConversationsRequest());
    return axios.get(`${constants.CHAT_SERVER_URL}/conversations`, {
      headers: { 'Authorization': `${localStorage.getItem('token')}` }
    })
      .then(res => {
        dispatch(getConversationsSuccess(res.data.data || []));
      })
      .catch(error => {
        dispatch(getConversationsFailure(error));
      });
  };
};

export const getMessages = (conversationId) => {
  return dispatch => {
    dispatch(getMessagesRequest());
    return axios.get(`${constants.CHAT_SERVER_URL}/conversations/${conversationId}/messages`, {
      headers: { 'Authorization': `${localStorage.getItem('token')}` }
    })
      .then(res => {
        dispatch(getMessagesSuccess(res.data.data || [], conversationId));
      })
      .catch(error => {
        dispatch(getMessagesFailure(error));
      });
  };
};

export const sendMessage = (conversationId, message) => {
  return dispatch => {
    dispatch(sendMessageRequest());
    return axios.post(`${constants.CHAT_SERVER_URL}/conversations/${conversationId}/messages`, 
      { message },
      {
        headers: { 'Authorization': `${localStorage.getItem('token')}` }
      }
    )
      .then(res => {
        dispatch(sendMessageSuccess(res.data.data || res.data));
      })
      .catch(error => {
        dispatch(sendMessageFailure(error));
      });
  };
};

export const getUnreadCount = () => {
  return dispatch => {
    return axios.get(`${constants.CHAT_SERVER_URL}/unread-count`, {
      headers: { 'Authorization': `${localStorage.getItem('token')}` }
    })
      .then(res => {
        const count = res.data.data?.unreadCount || 0;
        dispatch(setUnreadCount(count));
      })
      .catch(error => {
        console.error('Error fetching unread count:', error);
      });
  };
};

export const chatActions = {
  CHAT_CONVERSATIONS_REQUEST,
  CHAT_CONVERSATIONS_SUCCESS,
  CHAT_CONVERSATIONS_FAILURE,
  CHAT_MESSAGES_REQUEST,
  CHAT_MESSAGES_SUCCESS,
  CHAT_MESSAGES_FAILURE,
  CHAT_SEND_MESSAGE_REQUEST,
  CHAT_SEND_MESSAGE_SUCCESS,
  CHAT_SEND_MESSAGE_FAILURE,
  SET_ACTIVE_CONVERSATION,
  TOGGLE_CHAT_OPEN,
  SET_UNREAD_COUNT,
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_SUCCESS,
  CREATE_ANNOUNCEMENT_FAILURE,
  getConversations,
  getMessages,
  sendMessage,
  getUnreadCount,
  setActiveConversation,
  toggleChatOpen,
  setUnreadCount,
  createAnnouncement
};
